import React from "react";

import loadingIconLight from "../../assets/images/loading-light.gif";

const defaultSize = 64;

type XboxSpinnerProps = Readonly<{
  size?: number;
}>;

export const XboxSpinner = ({ size }: XboxSpinnerProps) => (
  <img
    aria-live="assertive"
    role="alert"
    alt="Xbox"
    src={loadingIconLight}
    tabIndex={-1}
    width={size ?? defaultSize}
    height={size ?? defaultSize}
  />
);
